import React, { Component } from 'react'
import classNames from 'classnames'

import styles from './WrappedInput.module.css'

export default class WrappedInput extends Component {
  state = {
    focussed: false,
  }

  getInputValue = e => {
    let { jsonOptions } = this.props
    let input = e.currentTarget
    let value = input.value

    if (input.tagName === 'SELECT') {
      let opt = input.selectedOptions[0]

      if (opt && opt.disabled) {
        return undefined
      }
    }

    if (jsonOptions && typeof value === 'string' && value.match(/^[\[\{]/)) {
      value = JSON.parse(value)
    }

    return value
  }

  handleChange = e => {
    let { input, onChangeValue } = this.props
    let { onChange } = input

    let value = this.getInputValue(e)

    onChange(value)

    if (onChangeValue) {
      onChangeValue(value)
    }
  }

  handleFocus = e => {
    let { input } = this.props
    let { onFocus } = input

    if (onFocus) {
      onFocus(e)
    }

    this.setState({ focussed: true })
  }

  handleBlur = e => {
    let { input } = this.props
    let { onBlur } = input

    let value = this.getInputValue(e)

    if (onBlur) {
      onBlur(value)
    }

    this.setState({ focussed: false })
  }

  stopPropagation = e => {
    e.stopPropagation()
  }

  forceFocus = () => {
    if (this.input) {
      this.input.focus()
    }
  }

  getOptions = () => {
    let { options, jsonOptions } = this.props

    if (options && jsonOptions) {
      return options.map(opt => {
        if (opt.value && typeof opt.value === 'object') {
          return {
            ...opt,
            value: JSON.stringify(opt.value),
          }
        }

        return opt
      })
    }

    return options
  }

  getValue = () => {
    let { input, jsonOptions } = this.props
    let { value } = input

    if (input.value && typeof input.value === 'object' && jsonOptions) {
      return JSON.stringify(value)
    }

    return value
  }

  setEmptyValue = () => {
    let { placeholder } = this.props
    let options = this.getOptions()
    let value = this.getValue()

    let index = placeholder ? 0 : -1

    let hasValue = false

    if (options) {
      for (let opt of options) {
        if (opt.value === value) {
          hasValue = true
        } else if (opt.options) {
          for (let childOpt of opt.options) {
            if (childOpt.value === value) {
              hasValue = true
            }
          }
        }
      }
    }

    if (options && this.select && !hasValue) {
      this.select.selectedIndex = index
    }
  }

  componentDidMount() {
    let { autoSelect } = this.props

    this.setEmptyValue()

    if (!autoSelect || !this.input) {
      return
    }

    this.input.focus()
    this.input.select()
  }

  componentDidUpdate() {
    this.setEmptyValue()
  }

  inputRef = input => {
    this.input = input
  }

  selectRef = select => {
    this.select = select
  }

  renderInput(inputProps) {
    let { input, placeholder } = this.props
    let options = this.getOptions()
    let value = this.getValue()

    if (options) {
      return (
        <select
          name={input.name}
          onChange={this.handleChange}
          value={value}
          ref={this.selectRef}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
        >
          {placeholder && <option disabled>{placeholder}</option>}
          {options.map(option =>
            option.options ? (
              <>
                <option disabled> </option>
                <optgroup label={option.label} key={option.label}>
                  {option.options.map(child => (
                    <option
                      value={child.value}
                      key={child.value}
                      disabled={child.disabled}
                    >
                      {child.label}
                    </option>
                  ))}
                </optgroup>
              </>
            ) : (
              <option
                key={option.value}
                value={option.value}
                disabled={option.disabled}
              >
                {option.label}
              </option>
            )
          )}
        </select>
      )
    }

    return (
      <input
        {...inputProps}
        {...input}
        className={styles.input}
        onChange={this.handleChange}
        onMouseDown={this.stopPropagation}
        onMouseUp={this.stopPropagation}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        ref={this.inputRef}
      />
    )
  }

  render() {
    let { focussed } = this.state

    let {
      meta,
      label,
      input,
      className,
      prefix,
      suffix,
      inverted,
      noPad,
      ...props
    } = this.props

    let { touched, error } = meta || {}

    return (
      <div
        onMouseDown={this.forceFocus}
        onMouseUp={this.forceFocus}
        className={classNames(styles.wrapper, className, {
          [styles.error]: touched && error,
          [styles.focussed]: focussed,
          [styles.inverted]: inverted,
          [styles.noPad]: noPad,
          [styles.empty]: !input.value,
        })}
      >
        {label ? <label>{label}</label> : null}
        <div className={styles.innerWrapper}>
          {prefix ? <div className={styles.prefix}>{prefix}</div> : null}
          <div className={styles.inputWrapper}>{this.renderInput(props)}</div>
          {suffix ? <div className={styles.suffix}>{suffix}</div> : null}
        </div>
        {touched && error ? (
          <div className={styles.errorMessage}>{error}</div>
        ) : null}
      </div>
    )
  }
}
